import { styled } from '@material-ui/core';
import DotSeparatorIcon from '@material-ui/icons/FiberManualRecord';

const DotSeparator = styled(DotSeparatorIcon)(({ theme }) => ({
  alignSelf: 'center',
  padding: theme.spacing(0, 1),
  fontSize: '20px'
}));

export default DotSeparator;
